import React from 'react'
import '../../App.css';

export default function NavbarLogReg() {
    return (
        <nav className="main-header-lr">
            <h1 className="heading">BRAINIFY</h1> 
        </nav>
    )
}
